import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';
import { CuadrillaDetallePage } from '../cuadrilla-detalle/cuadrilla-detalle';
import { FincasDetallePage } from '../fincas-detalle/fincas-detalle';
/**
 * Generated class for the EncargadoDetallePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-encargado-detalle',
  templateUrl: 'encargado-detalle.html',
})
export class EncargadoDetallePage {
  item = {aid : null, aNombre: null};
  cuadrillas = [];
  fincas = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public partesService : PartesService) {
    if(navParams.data.item != 0){ 
      this.item = navParams.data.item;
    }    
    this.cuadrillas = this.partesService.cuadrillas;
    this.fincas = this.partesService.fincas;
  }

  //Añadir Encargado
  addEncargado(){
    this.partesService.addEncargado(this.item);
    this.navCtrl.pop();
  } 

  //Borrar Cuadrilla
  deleteEncargado(){
    let alert = this.alertCtrl.create({
      title: 'Confirmar borrado',
      message: '¿Estás seguro de que deseas eliminar este Encargado?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            // Ha respondido que no así que no hacemos nada
          }
        },
        {
          text: 'Si',
          handler: () => {
               // Aquí borramos el sitio en la base de datos
               this.partesService.deleteEncargado(this.item);
               this.navCtrl.pop();
           }
        }
      ]
    });
    alert.present();
  }  

  itemSelectedCuadrilla(item){
    this.navCtrl.push(CuadrillaDetallePage, { item : item });
  }
  
  insertarCuadrilla(){
    this.navCtrl.push(CuadrillaDetallePage, { item : 0});
  }
 
  itemSelectedFinca(item){
    this.navCtrl.push(FincasDetallePage, { item : item });
  }
  
  insertarFinca(){
    this.navCtrl.push(FincasDetallePage, { item : 0});
  }
 
  ionViewWillEnter(){
    this.cuadrillas = this.partesService.cuadrillas;
    this.fincas = this.partesService.fincas;
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad EncargadoDetallePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/encargado-detalle/encargado-detalle.ts